import gridStyles from '../../SchedulerPage/components/Grid/Grid.module.css';
import type { IPlanWindow, RestTone } from './workPlanModel';
import styles from './dayShading.module.css';

export interface IDayShadingProps {
  window: IPlanWindow;
}

/** The Gantt canvas's own column tints (Grid.module.css). */
const REST_COL: Record<RestTone, string> = {
  saturday: gridStyles.saturdayCol as string,
  sunday: gridStyles.sundayCol as string,
  rest: gridStyles.restCol as string,
};

/** What a timeline cell paints under its marks: the Gantt canvas's rest-day
 *  columns, and today's column in the today blue. Only those columns get a
 *  node; the day lines are the cell's own background. */
export function DayShading({ window }: IDayShadingProps) {
  return (
    <>
      {window.days.map((day, i) => [
        day.rest && (
          <span key={`r${day.date}`} className={`${REST_COL[day.rest]} ${styles.col}`} style={{ gridColumn: i + 1 }} aria-hidden />
        ),
        day.isToday && <span key={`t${day.date}`} className={styles.today} style={{ gridColumn: i + 1 }} aria-hidden />,
      ])}
    </>
  );
}
